import { Skeleton } from 'antd'

export default function PlanCardSkeleton() {
    return (
        <div className='shadow-sm border-gray-200 border rounded-lg'>
            <div className='p-6 border-b border-gray-200'>
                <Skeleton className='mb-4' active paragraph={{ rows: 1, width: 150 }} />
                <Skeleton.Button block />
            </div>
            <div className="p-6">
                <Skeleton className='mb-4' active paragraph={{ rows: 3, width: 150 }} />
            </div>
        </div>
    )
}